import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/SkeletonLoader.tsx");
